import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMixAndMatch } from "src/models/Offers/MixAndMatch.models";

interface MixAndMatchState {
  mixAndMatches: IMixAndMatch[];
  mixAndMatchToEdit: IMixAndMatch | null;
}

const initialState: MixAndMatchState = {
  mixAndMatches: [],
  mixAndMatchToEdit: null,
};

const MixAndMatchSlice = createSlice({
  name: "MixAndMatch",
  initialState,
  reducers: {
    setMixAndMatchList: (state, action: PayloadAction<IMixAndMatch[]>) => {
      state.mixAndMatches = action.payload;
    },
    concatListMixAndMatch: (
      state: MixAndMatchState,
      action: PayloadAction<IMixAndMatch[]>
    ) => {
      state.mixAndMatches = [...state.mixAndMatches.concat(action.payload)];
    },
    setMixAndMatchToEdit: (
      state,
      action: PayloadAction<IMixAndMatch | null>
    ) => {
      state.mixAndMatchToEdit = action.payload;
    },
    addMixAndMatch: (state, action: PayloadAction<IMixAndMatch>) => {
      state.mixAndMatches.push(action.payload);
    },
    updateMixAndMatch: (state, action: PayloadAction<IMixAndMatch>) => {
      let itemIndex = state.mixAndMatches.findIndex(
        item => item.mixAndMatchId === action.payload.mixAndMatchId
      );
      if (itemIndex !== -1) state.mixAndMatches[itemIndex] = action.payload;
    },
    deleteMixAndMatch: (state, action: PayloadAction<number>) => {
      const newArray = state.mixAndMatches.filter(
        item => item.mixAndMatchId !== action.payload
      );
      state.mixAndMatches = newArray;
    },
  },
});

export const {
  setMixAndMatchList,
  concatListMixAndMatch,
  setMixAndMatchToEdit,
  addMixAndMatch,
  updateMixAndMatch,
  deleteMixAndMatch,
} = MixAndMatchSlice.actions;

export default MixAndMatchSlice.reducer;
